import React from 'react'
import {XTerm} from 'updated-xterm-for-react'
import {useEffect} from "react";
import {Button, Card, OverlayTrigger, Tooltip} from "react-bootstrap";
import {AiOutlineClear} from "react-icons/ai";
import './xterm.css'

export default function UpgradeTerminal({lastLog}) {
    const xtermRef = React.useRef(null)

    useEffect(() => {
        xtermRef.current.terminal.resize(145, 20);
        if (lastLog) {
            xtermRef.current.terminal.clear();
            xtermRef.current.terminal.write(lastLog);
            xtermRef.current.terminal.scrollToBottom()
        }
    }, [lastLog])

    return (
        <Card bsPrefix={'terminalCard'}>
            <Card.Header style={{paddingTop: 0, paddingBottom: 0}}>
                <div style={{display: 'flex', justifyContent: 'end'}}>
                    <OverlayTrigger placement="top" overlay={<Tooltip>Clear logs</Tooltip>}>
                        <Button
                            bsPrefix={'clear'}
                            className='p-0 m-0' variant={'link'}
                            style={{outline: 'none !important'}}>
                            <AiOutlineClear onClick={() => xtermRef.current.terminal.clear()} size={20}/>
                        </Button>
                    </OverlayTrigger>
                </div>
            </Card.Header>
            <Card.Body style={{paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0}}>
                <XTerm ref={xtermRef} options={{cursorBlink: true, scrollback: 10000}}/>
            </Card.Body>
        </Card>
    )
}
